import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { FileKeyFacilitationState } from '@/types/fileKey/FileKeyFacilitation';

const initialState: FileKeyFacilitationState = {
  status: 'idle',
  processedCount: 0,
  totalCount: 0,
  errors: [],
  rerunRequested: false,
};

const fileKeyFacilitationSlice = createSlice({
  name: 'fileKeyFacilitation',
  initialState,
  reducers: {
    /** Claims the run. Dispatched before the first await so concurrent triggers see `running`. */
    startFacilitation(state) {
      state.status = 'running';
      state.totalCount = 0;
      state.processedCount = 0;
      state.errors = [];
      state.rerunRequested = false;
    },
    /** Once per pass, after the missing-keys response is known. Errors stay cumulative. */
    facilitationTotalCounted(state, action: PayloadAction<{ totalCount: number }>) {
      state.totalCount = action.payload.totalCount;
      state.processedCount = 0;
    },
    fileKeyProcessed(state) {
      state.processedCount += 1;
    },
    fileKeyFailed(state, action: PayloadAction<string>) {
      state.errors.push(action.payload);
    },
    requestRerun(state) {
      state.rerunRequested = true;
    },
    clearRerunRequest(state) {
      state.rerunRequested = false;
    },
    facilitationComplete(state) {
      state.status = state.errors.length > 0 ? 'error' : 'complete';
    },
  },
});

export const {
  startFacilitation,
  facilitationTotalCounted,
  fileKeyProcessed,
  fileKeyFailed,
  requestRerun,
  clearRerunRequest,
  facilitationComplete,
} = fileKeyFacilitationSlice.actions;

export default fileKeyFacilitationSlice.reducer;
